import * as EvaluationsClient from '../clients/EvaluationsClient'
import * as PredictionConfigClient from '../clients/PredictionConfigClient'
import * as ConfigurationClient from '../clients/ConfigurationClient'

export default class SuccessByPredictionConfigList {
  constructor() {
  }
  async load(criteria) {
      var evaluations = await EvaluationsClient.getEvaluations(criteria)
      var config = await ConfigurationClient.getPredictionSettings()
      var successByPredictionConfigObj = {}
      var tagVersions = []
      for (var i = 0; i < evaluations.length; i++) {
        var evaluation = evaluations[i]
        var name = evaluation.predictionConfig.name
        var tagVersion = evaluation.tagVersion || evaluation.dataset.tagVersion
        if (!successByPredictionConfigObj[name]) successByPredictionConfigObj[name] = {}
        if (!successByPredictionConfigObj[name][tagVersion]) successByPredictionConfigObj[name][tagVersion] = {winPercentage:[], rpr: []}
        successByPredictionConfigObj[name][tagVersion].winPercentage.push(evaluation.winPercentage)
        successByPredictionConfigObj[name][tagVersion].rpr.push(evaluation.rpr)
        if (tagVersions.indexOf(tagVersion) === -1) tagVersions.push(tagVersion)
      }
      var configList = Object.keys(successByPredictionConfigObj).map(key => {
        return {name: key, tagVersions: successByPredictionConfigObj[key]}
      })

      this.configList = configList
      this.tagVersions = tagVersions
      this.configList = this.configList.map(obj => {
        if(obj.name === config.data.predictionConfig) obj.isUsedForPredictions = true
        return obj
      })
      return {
        configList: this.configList,
        tagVersions: tagVersions
      }
  }
  async addLiveStatus() {
    var list = await PredictionConfigClient.listPredictionConfigs()
    list = list.map(item => item.replace("prediction_config/live/", "").replace('.json',""))
    this.configList.forEach(config => {
      if (list.indexOf(config.name) > -1) config.isLive = true
    })
    this.configList.sort((a,b) => a.isLive? -1 : !a.isLive? 1 : 0)
  }
}
